import { BiDownload, BiChevronDown, BiRightArrowAlt } from "react-icons/bi";
import TypewritterHeader from "./TypewritterHeader";
import Skills from "../../common/Skills";
import { Link } from "react-router-dom";

export default function Presentation() {
  // --- Lógica de Scroll Copiada ---
  const HEADER_HEIGHT = 80;

  const handleScrollToAbout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // Evita el salto brusco del anchor original
    const el = document.querySelector("#about");
    if (!el) return;

    const top = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
    window.scrollTo({ top, behavior: "smooth" });
  };
  // -------------------------------

  return (
    <div className="relative min-h-[calc(100vh-4rem)] flex flex-col justify-center w-full py-16">
      {/* Main heading */}
      <TypewritterHeader />

      {/* Tagline */}
      <p className="text-xl text-gray-400 mt-4 max-w-xl leading-relaxed">
        Construyendo el futuro,{" "}
        <span className="text-white font-medium">línea por línea.</span>
      </p>

      {/* CTAs */}
      <div className="flex gap-3 sm:flex-row flex-col mt-8 items-start">
        <a
          href="CV_Franco_Martino.pdf"
          download="CV_Franco_Martino.pdf"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium
            hover:bg-green-300/10 border border-green-300/40 bg-green-300 text-gray-800 hover:border-green-300/70 hover:text-white
            transition-all duration-200"
        >
          <BiDownload size={16} />
          Descargar CV
        </a>

        <Link
          to="/contact"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-medium
            bg-gray-800/60 border border-gray-700/50 text-gray-300
            hover:bg-gray-700/60 hover:border-gray-600 hover:text-white
            transition-all duration-200"
        >
          Contactarme
          <BiRightArrowAlt size={16} />
        </Link>
      </div>

      {/* Tech stack */}
      <Skills className="mt-8 md:flex hidden !justify-start" techs top />

      {/* Scroll indicator - Se agregó el onClick y la función */}
      <a
        href="#about"
        onClick={handleScrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-gray-600 hover:text-gray-400 transition-colors duration-300 cursor-pointer"
      >
        <span className="text-xs tracking-widest uppercase">VER MÁS</span>
        <BiChevronDown size={20} className="animate-bounce" />
      </a>
    </div>
  );
}
